import { DialogActions as MuiDialogActions, colors } from '@mui/material';

export function DialogActions(props) {
  const { dark, sx, ...passThroughProps } = props;
  return (
    <MuiDialogActions
      sx={{
        ...(dark
          ? {
              bgcolor: colors.grey[800],
              '& .MuiButton-root.Mui-disabled': {
                bgcolor: '#eaeaea',
              },
            }
          : null),
        ...sx,
      }}
      {...passThroughProps}
    />
  );
}
